import React, { useRef, useContext, useState, useEffect } from 'react';

import { Portal as UIPortal } from '@gogame/components';

export const PortalContext = React.createContext();

export const PortalProvider = ({ children }) => {
  const [activePortals, setActivePortals] = useState({});
  const containersRef = useRef({});

  const registerContainer = (portalId) => (element) => {
    containersRef.current[portalId] = element;
  };

  const getContainer = (portalId) => containersRef.current[portalId];

  return (
    <PortalContext.Provider
      value={{
        registerContainer,
        getContainer,
        activePortals,
        setActivePortals,
      }}
    >
      {children}
    </PortalContext.Provider>
  );
};

export const Portal = ({ portalId, children }) => {
  const { setActivePortals, getContainer } = useContext(PortalContext);

  useEffect(() => {
    setActivePortals((activePortals) => ({
      ...activePortals,
      [portalId]: true,
    }));

    return () => {
      setActivePortals((activePortals) => ({
        ...activePortals,
        [portalId]: false,
      }));
    };
  }, []);

  return <UIPortal container={getContainer(portalId)}>{children}</UIPortal>;
};

export const Container = ({ portalId, component = `div`, item, ...props }) => {
  const { registerContainer, activePortals } = useContext(PortalContext);

  let elementProps = {
    ref: registerContainer(portalId),
    style: activePortals[portalId] ? null : { display: 'none' },
    ['data-cy']: 'portal-' + portalId,
    ...props,
  };
  if (String(item)?.toLowerCase() === 'true') {
    elementProps.item = true;
  }
  return React.createElement(component, elementProps);
};
